import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import LinearProgress from '@mui/material/LinearProgress'
import Paper from '@mui/material/Paper'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

function TableContentSkeleton() {
  return (
    <Box
      aria-label="Loading tables"
      aria-busy="true"
      sx={{
        display: 'grid',
        gridTemplateColumns: {xs: '1fr', xl: 'minmax(0, 1fr) 360px'},
        gap: 1.25,
        alignItems: 'stretch',
      }}
    >
      <Paper variant="outlined" sx={{borderRadius: 2.5, overflow: 'hidden', minWidth: 0}}>
        <LinearProgress />
        <Box sx={{p: 2}}>
          <Stack direction="row" justifyContent="flex-end" spacing={1} sx={{mb: 2}}>
            <Skeleton variant="rounded" width={220} height={40} />
            <Skeleton variant="rounded" width={130} height={40} />
          </Stack>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)', lg: 'repeat(5, 1fr)'},
              gap: 1.25,
            }}
          >
            {Array.from({length: 20}, (_, index) => (
              <Skeleton key={index} variant="rounded" height={108} animation="wave" />
            ))}
          </Box>
        </Box>
      </Paper>
      <Paper variant="outlined" sx={{borderRadius: 2.5, p: 2.25, minHeight: 620}}>
        <Skeleton width="45%" height={34} />
        <Skeleton variant="rounded" width={82} height={22} sx={{mt: 0.5}} />
        <Skeleton sx={{mt: 3}} width="35%" />
        <Stack direction="row" spacing={1}>
          <Skeleton variant="rounded" height={40} sx={{flex: 1}} />
          <Skeleton variant="rounded" width={90} height={40} />
        </Stack>
        <Skeleton variant="rounded" height={120} sx={{mt: 3}} />
        <Skeleton variant="rounded" height={48} sx={{mt: 2.5}} />
        <Skeleton variant="rounded" height={110} sx={{mt: 2.5}} />
        <Skeleton variant="rounded" height={110} sx={{mt: 1.5}} />
      </Paper>
    </Box>
  )
}

export default function TableManagementSkeleton({fullPage = false}) {
  if (!fullPage) return <TableContentSkeleton />

  return (
    <Container maxWidth={false} sx={{pt: 0, pb: 3, px: {xs: 1.5, sm: 3}}}>
      <Stack spacing={0.5} sx={{mb: 1.25}}>
        <Skeleton width={190} height={24} />
        <Skeleton width={245} height={38} />
        <Skeleton width={390} height={24} />
      </Stack>
      <Stack direction="row" spacing={1} sx={{mb: 1.5}}>
        {Array.from({length: 5}, (_, index) => (
          <Skeleton key={index} variant="rounded" width={105} height={32} />
        ))}
      </Stack>
      <Stack direction="row" spacing={1} sx={{mb: 1.5}}>
        <Skeleton variant="rounded" width={130} height={38} />
        <Skeleton variant="rounded" width={150} height={38} />
        <Skeleton variant="rounded" width={120} height={38} />
      </Stack>
      <TableContentSkeleton />
    </Container>
  )
}
